import { trans } from '@lingoda/i18n';
import GoalConfetti from '../illustrations/goal-confetti.svg?component';
import GoalSpeed from '../illustrations/goal-speed.svg?component';
import GoalStars from '../illustrations/goal-stars.svg?component';
import type { ComponentType } from 'react';

interface BookingComboParams {
    content: { title: string; message: string };
    Icon: ComponentType;
}

export const getBookingComboParams = (bookingCount: number): BookingComboParams => {
    if (bookingCount === 1 || bookingCount > 4) {
        return {
            content: {
                title: trans('way-to-go', {}, 'student-notification'),
                message: trans('class-booked-successfully', {}, 'student-notification'),
            },
            Icon: GoalConfetti,
        };
    }

    if (bookingCount === 2) {
        return {
            content: {
                title: trans('keep-going', {}, 'student-notification'),
                message: trans('class-booked-successfully', {}, 'student-notification'),
            },
            Icon: GoalStars,
        };
    }

    if (bookingCount === 3) {
        return {
            content: {
                title: trans('you-are-on-fire-today', {}, 'student-notification'),
                message: trans('class-booked-successfully', {}, 'student-notification'),
            },
            Icon: GoalSpeed,
        };
    }

    return {
        content: {
            title: trans('really-planning-ahead', {}, 'student-notification'),
            message: trans('class-booked-successfully', {}, 'student-notification'),
        },
        Icon: GoalStars,
    };
};
